import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik"; import Menubar from "../Menubar"; import { store } from "../../App"; import MasterService from "../../Services/MasterService";
import autoTable from "jspdf-autotable"; import { Row, Col, Container } from "react-bootstrap"; import KpiService from "../../Services/KpiService"; import { Button } from "reactstrap"; import { FaRegSave } from "react-icons/fa";
import useAlert from "../Alert/useAlert"; import AlertModal from "../Alert/AlertModal"; import  { isValidtwo, percentcal, } from "../utils/commonFunctions";

export default function GsdpEstimates() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [distlist, setDistlist] = useState([]); const [mandallist, setMandallist] = useState(); const [EntryData, setEntrydata] = useState(); const [entrydataEnb, setEntrydataEnb] = useState(false);
  const [districtName, setDistrictName] = useState("");
  const [districtnamelist, setDistrictnamelist] = useState(); const [mandalName, setMandalname] = useState(""); const [mandalnamelist, setMandalnamelist] = useState();
 const [sequenceId, setSequenceid] = useState(); const [buttonenb, setButtonenb] = useState();
  let username = localStorage.getItem("username"); let roleid = localStorage.getItem("role"); let district = localStorage.getItem("districtid");

  const years = Array.from({ length: 27 }, (_, index) => 22 + index); // [23, 24, ..., 48]
  const initialGsdpEstimates = years.map(() => ({
    ...years.reduce((acc, year) => {
      acc[`rps_${year}`] = "";
      acc[`percent_${year}`] = "";
      return acc;
    }, {}),
  }));

  const formik = useFormik({
    initialValues: { district_id: "", mandal_id: "", Gsdp_estimates: initialGsdpEstimates, },
  });

  useEffect(() => {
    MasterService.getDistricts().then((res) => {
      if (res.data) {
        setDistrictnamelist(res.data);
        let options = res.data.map((item, i) => {
          return ( <option key={i} value={item.id}> {item.value} </option> );
        });
        setDistlist(options);
        if (roleid === "2") {
         let filtereddistrict=res.data?.find(item=>item.id === district);
          setName( filtereddistrict[0]?.id)
          console.log("filtereddistrict[0]?.id",district)
        }
      }
    });
    let params = { district_id: district };
    MasterService.getMandals(params).then((mandalRes) => {
      setMandalnamelist(mandalRes.data);
      if (mandalRes) { let options = mandalRes.data.map((item, i) => ( <option key={i} value={item.id}> {item.value} </option> ));
        setMandallist(options);
      }
    });
 
  }, []);
  const[name,setName]=useState("")
  const gethodData = (e) => {
    const filterdist = districtnamelist.filter( (item) => item.id == e.target.value );
    setDistrictName(filterdist[0]?.value);
    const clearedEstimates = formik.values.Gsdp_estimates.map((item) => { const clearedItem = {}; for (let year = 2022; year <= 2046; year++) { const frontend = `${year}`.slice(-2); clearedItem[`rps_${frontend}`] = ""; clearedItem[`percent_${frontend}`] = ""; } return clearedItem; });
    formik.setFieldValue("Gsdp_estimates", clearedEstimates);
let params = { userId: username, districtId: e.target.value, mandalId: "", };

    KpiService.gsdpestimatesSector(params).then((res) => {
      if (res.data.SCODE === "01") {
        setEntrydataEnb(true); setEntrydata(res.data.SDESC);
// let button=false
        res.data.SDESC.forEach((item, i) => {
          for (let year = 2022; year <= 2047; year++) {
            const nextYear = year + 1;
            const formKey = `${year}_${String(nextYear).slice(2)}`;
            const frontend = `${year}`.slice(-2);
            const gsdpValue = item[`gsdp_price_${formKey}`];
            const percentageValue = item[`percentage_year_${formKey}`];
            const finalGsdpValue =
              gsdpValue === 0 || gsdpValue === "0" ? "" : gsdpValue;
            const finalPercentageValue =
              percentageValue === 0 || percentageValue === "0"
                ? ""
                : percentageValue;

            formik.setFieldValue(
              `Gsdp_estimates[${i}].rps_${frontend}`,
              finalGsdpValue
            );
            formik.setFieldValue(
              `Gsdp_estimates[${i}].percent_${frontend}`,
              finalPercentageValue
            );
            formik.setFieldValue(`Gsdp_estimates[${i}].nettaxes_${year}`, "5");
            // console.log("val", `Gsdp_estimates[${i}].nettaxes_${year}`);
          }
          if (item.sequance_id !== null) {
            setSequenceid(item.sequance_id);
          }
          if (res.data.SDESC.some((item) => item.status_id === "2")) {
            setButtonenb(false);
          } else {
            setButtonenb(true);
          }
        });
    
      }
    });
  };

  const getGsdpEstimates = (mandal) => {
    const clearedEstimates = formik.values.Gsdp_estimates.map((item) => {
      const clearedItem = {};
      for (let year = 2022; year <= 2047; year++) {
        const frontend = `${year}`.slice(-2);
        clearedItem[`rps_${frontend}`] = "";
        clearedItem[`percent_${frontend}`] = "";
      }
      return clearedItem;
    });
    formik.setFieldValue("Gsdp_estimates", clearedEstimates);
    const filtermandal = mandalnamelist.filter((item) => item.id == mandal);
    setMandalname(filtermandal[0]?.value);
    let params = {
      userId: username,
      districtId: district,
      mandalId: mandal,
    };

    KpiService.gsdpestimatesSector(params)
      .then((res) => {
        if (res.data.SCODE === "01") {
          setEntrydataEnb(true);
          setEntrydata(res.data.SDESC);
          // let button=false
          // Log the backend data array to see its structure
          res.data.SDESC.forEach((item, i) => {
// console.log("dsec",res.data.SDESC)

            for (let year = 2022; year <= 2047; year++) {
              const nextYear = year + 1;
              const formKey = `${year}_${String(nextYear).slice(2)}`;
              // console.log("formKey",formKey)
              const frontend = `${year}`.slice(-2);
              const gsdpValue = item[`gsdp_price_${formKey}`];
              const percentageValue = item[`percentage_year_${formKey}`];
              const finalGsdpValue = gsdpValue === 0 || gsdpValue === "0" ? "" : gsdpValue;
              const finalPercentageValue = percentageValue === 0 || percentageValue === "0" ? "" : percentageValue;
              store.dispatch({ type: "SHOW_SPINNER" });
              formik.setFieldValue( `Gsdp_estimates[${i}].rps_${frontend}`, finalGsdpValue );
              formik.setFieldValue( `Gsdp_estimates[${i}].percent_${frontend}`, finalPercentageValue );
            }
            if (item.sequance_id !== null) {
              setSequenceid(item.sequance_id);
            }
      // If any item has status_id === 2, disable the button by setting its enabled state to false
      if (res.data.SDESC.some((item) => item.status_id === "2")) {
        setButtonenb(false);
      } else {
        setButtonenb(true);
      }
          });
         
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };



  const startYear = 2022;
  const endYear = 2047;

  const generateYears = () => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(`${year}-${(year + 1).toString().slice(-2)}`);
    }
    return years;
  };

  useEffect(() => {
    setTimeout(() => {
      formik.setValues((prevValues) => {
        // Ensure both the Gsdp_estimates array and the backend data (EntryData) are available
        if (
          !prevValues.Gsdp_estimates ||
          !Array.isArray(prevValues.Gsdp_estimates) ||
          !EntryData ||
          !Array.isArray(EntryData)
        ) {
          return prevValues;
        }
  
        // Create a working copy of the estimates
        let updated = [...prevValues.Gsdp_estimates];
        let hasChanges = false;
  
       
  // ==================================================
// Part 1: Totals Calculations Based on Backend broad_sector_id
// ==================================================
// Grouping:
// - broad_sector_id 1 summed → display in sector_id 6
// - broad_sector_id 2 summed → display in sector_id 11
// - broad_sector_id 3 summed → display in sector_id 21
const grouped = [
  { broadSector: 1, targetSector: 6 },
  { broadSector: 2, targetSector: 11 },
  { broadSector: 3, targetSector: 21 }
];
 
// Initialize accumulators for each target sector for each year (key: last two digits)
const groupSums = {};
grouped.forEach((group) => {
  groupSums[group.targetSector] = {};
  for (let year = 2022; year <= 2047; year++) {
    const key = `${year}`.slice(-2);
    groupSums[group.targetSector][key] = 0;
  }
});
 
// Loop over each row and add its value to the proper group (using EntryData for backend broad_sector_id)
updated.forEach((row, index) => {
  const backendRow = EntryData[index];
  if (backendRow && backendRow.broad_sector_id != null) {
    const broadSectorId = Number(backendRow.broad_sector_id);
    grouped.forEach((group) => {
      if (broadSectorId === group.broadSector) {
        for (let year = 2022; year <= 2047; year++) {
          const key = `${year}`.slice(-2);
          const value = parseFloat(row[`rps_${key}`]) || 0;
          groupSums[group.targetSector][key] += value;
        }
      }
    });
  }
});
 
// For each grouping, find the target row by matching backend sector_id and update its values
grouped.forEach((group) => {
  const targetIndex = EntryData.findIndex(
    (item) => Number(item.sector_id) === group.targetSector
  );
  if (targetIndex !== -1) {
    for (let year = 2022; year <= 2047; year++) {
      const key = `${year}`.slice(-2);
      const newRpsValue = parseFloat(groupSums[group.targetSector][key].toFixed(2));
      if (updated[targetIndex][`rps_${key}`] !== newRpsValue) {
        updated[targetIndex][`rps_${key}`] = newRpsValue;
        hasChanges = true;
      }
    }
  }
});


// ==================================================
      // Part 2: Percentage Calculation for Non-Target Rows
      // ==================================================
      // Determine target sectors to skip auto-calculation (they are already auto‐calculated)
//       const targetSectors = grouped.map((group) => group.targetSector);
// updated = updated.map((row, rowIndex) => {
//   // Skip auto‑calculation for target rows.
//   if (EntryData[rowIndex] && targetSectors.includes(Number(EntryData[rowIndex].sector_id))) {
//     return row;
//   }

//   // Only skip if the row is manually overridden AND there’s no percentage provided.
//   if (
//     row.manualOverride &&
//     Object.keys(row).filter((key) => key.startsWith("percent_")).every((key) => row[key] === "" || row[key] == null)
//   ) {
//     return row;
//   }

//   let updatedRow = { ...row };
//   let localChange = false;
//   const sectorId = EntryData[rowIndex] ? Number(EntryData[rowIndex].sector_id) : null;

//   for (let year = 22; year < 48; year++) {
//     const currentKey = `rps_${year}`;
//     const nextKey = `rps_${year + 1}`;
//     const percentKey = `percent_${year + 1}`;

//     const baseValue = parseFloat(updatedRow[currentKey]);
//     const percentStr = row[percentKey];
//     const percentValue = parseFloat(percentStr);
//     const backendValue = EntryData[rowIndex] ? EntryData[rowIndex][nextKey] : null; // Backend value

//     if (percentStr === "" || percentStr == null) {
//       if (sectorId === 27) {
//         // For sector_id 27, use backend value if available
//         if (backendValue !== null && backendValue !== undefined) {
//           if (updatedRow[nextKey] !== backendValue) {
//             updatedRow[nextKey] = backendValue;
//             localChange = true;
//           }
//         }
//       } else {
//         // For other sectors, set GSDP price to empty
//         if (updatedRow[nextKey] !== "") {
//           updatedRow[nextKey] = "";
//           localChange = true;
//         }
//       }
//     } else {
//       if (!isNaN(baseValue)) {
//         if (isNaN(percentValue) || percentValue === 0) {
//           const baseFixed = baseValue.toFixed(2);
//           if (updatedRow[nextKey] !== baseFixed) {
//             updatedRow[nextKey] = baseFixed;
//             localChange = true;
//           }
//         } else {
//           const calculatedValue = (baseValue * (1 + percentValue / 100)).toFixed(2);
//           if (updatedRow[nextKey] !== calculatedValue) {
//             updatedRow[nextKey] = Math.round(calculatedValue);
//             localChange = true;
//           }
//         }
//       }
//     }
//   }

//   if (localChange) {
//     hasChanges = true;
//     return updatedRow;
//   }
//   return row;
// });

      
const targetSectors = grouped.map((group) => group.targetSector);
updated = updated.map((row, rowIndex) => {
  // Skip auto‑calculation for target rows.
  if (EntryData[rowIndex] && targetSectors.includes(Number(EntryData[rowIndex].sector_id))) {
    return row;
  }

  // Only skip if the row is manually overridden AND there’s no percentage provided.
  if (
    row.manualOverride &&
    Object.keys(row).filter((key) => key.startsWith("percent_")).every((key) => row[key] === "" || row[key] == null)
  ) {
    return row;
  }

  let updatedRow = { ...row };
  let localChange = false;
  const sectorId = EntryData[rowIndex] ? Number(EntryData[rowIndex].sector_id) : null;

  for (let year = 22; year < 48; year++) {
    const currentKey = `rps_${year}`;
    const nextKey = `rps_${year + 1}`;
    const percentKey = `percent_${year + 1}`;

    const baseValue = parseFloat(updatedRow[currentKey]);
    const percentStr = row[percentKey];
    const percentValue = parseFloat(percentStr);
    const backendValue = EntryData[rowIndex] ? EntryData[rowIndex][nextKey] : null; // Backend value

    // If the current GSDP is empty, clear the next GSDP and percentage
    if (!updatedRow[currentKey] || updatedRow[currentKey] === "") {
      if (updatedRow[nextKey] !== "") {
        updatedRow[nextKey] = "";
        localChange = true;
      }
      if (updatedRow[percentKey] !== "") {
        updatedRow[percentKey] = "";
        localChange = true;
      }
      continue; // Skip further calculations
    }

    if (percentStr === "" || percentStr == null) {
      if (sectorId === 27) {
        // For sector_id 27, use backend value if available
        if (backendValue !== null && backendValue !== undefined) {
          if (updatedRow[nextKey] !== backendValue) {
            updatedRow[nextKey] = backendValue;
            localChange = true;
          }
        }
      } else {
        // For other sectors, set GSDP price and percentage to empty
        if (updatedRow[nextKey] !== "") {
          updatedRow[nextKey] = "";
          localChange = true;
        }
        if (updatedRow[percentKey] !== "") {
          updatedRow[percentKey] = "";
          localChange = true;
        }
      }
    } else {
      if (!isNaN(baseValue)) {
        if (isNaN(percentValue) || percentValue === 0) {
          const baseFixed = baseValue.toFixed(2);
          if (updatedRow[nextKey] !== baseFixed) {
            updatedRow[nextKey] = baseFixed;
            localChange = true;
          }
        } else {
          const calculatedValue = (baseValue * (1 + percentValue / 100)).toFixed(2);
          if (updatedRow[nextKey] !== calculatedValue) {
            updatedRow[nextKey] = Math.round(calculatedValue);
            localChange = true;
          }
        }
      }
    }
  }

  if (localChange) {
    hasChanges = true;
    return updatedRow;
  }
  return row;
});


        // ==================================================
        // Part 3: Additional Calculations
        // ==================================================
  
        // 3.1 Sum of sector_id 6 + sector_id 11 + sector_id 21 → Display at sector_id 22
        let sum6_11_21 = {};
        for (let year = 2022; year <= 2047; year++) {
          const key = `${year}`.slice(-2);
          sum6_11_21[key] = 0;
          [6, 11, 21].forEach((sec) => {
            const idx = EntryData.findIndex(item => Number(item.sector_id) === sec);
            if (
              idx !== -1 &&
              updated[idx] &&
              updated[idx][`rps_${key}`] !== undefined &&
              updated[idx][`rps_${key}`] !== ""
            ) {
              sum6_11_21[key] += parseFloat(updated[idx][`rps_${key}`]);
            }
          });
        }
        const idx22 = EntryData.findIndex(item => Number(item.sector_id) === 22);
        if (idx22 !== -1) {
          for (let year = 2022; year <= 2047; year++) {
            const key = `${year}`.slice(-2);
            const newVal = parseFloat(sum6_11_21[key].toFixed(2));
            if (updated[idx22][`rps_${key}`] !== newVal) {
              updated[idx22][`rps_${key}`] = newVal;
              hasChanges = true;
            }
          }
        }
  
        // 3.2 Sum of sector_id 22 + sector_id 29 → Display at sector_id 25
        let sum22_29 = {};
        for (let year = 2022; year <= 2047; year++) {
          const key = `${year}`.slice(-2);
          let val22 = 0, val29 = 0;
          const idx22_for_sum = EntryData.findIndex(item => Number(item.sector_id) === 22);
          const idx29 = EntryData.findIndex(item => Number(item.sector_id) === 29);
          if (
            idx22_for_sum !== -1 &&
            updated[idx22_for_sum] &&
            updated[idx22_for_sum][`rps_${key}`] !== undefined &&
            updated[idx22_for_sum][`rps_${key}`] !== ""
          ) {
            val22 = parseFloat(updated[idx22_for_sum][`rps_${key}`]);
          }
          if (idx29 !== -1 && updated[idx29]) {
            // If the value for sector_id 29 is empty or not a valid number, treat it as 0
            const parsedVal29 = parseFloat(updated[idx29][`rps_${key}`]);
            val29 = isNaN(parsedVal29) ? 0 : parsedVal29;
          }
          sum22_29[key] = val22 + val29;
        }
        const idx25 = EntryData.findIndex(item => Number(item.sector_id) === 25);
        if (idx25 !== -1) {
          for (let year = 2022; year <= 2047; year++) {
            const key = `${year}`.slice(-2);
            const newVal = parseFloat(sum22_29[key].toFixed(2));
            if (updated[idx25][`rps_${key}`] !== newVal) {
              updated[idx25][`rps_${key}`] = newVal;
              hasChanges = true;
            }
          }
        }
  
        // 3.3 Ratio: sector_id 26 divided by sector_id 27 * 100000 (rounded to nearest whole number) → Display at sector_id 28
        let ratio26_27 = {};
        for (let year = 2022; year <= 2047; year++) {
          const key = `${year}`.slice(-2);
          let val26 = 0, val27 = 0;
          const idx26 = EntryData.findIndex(item => Number(item.sector_id) === 26);
          const idx27 = EntryData.findIndex(item => Number(item.sector_id) === 27);
          if (
            idx26 !== -1 &&
            updated[idx26] &&
            updated[idx26][`rps_${key}`] !== undefined &&
            updated[idx26][`rps_${key}`] !== ""
          ) {
            val26 = parseFloat(updated[idx26][`rps_${key}`]);
          }
          if (
            idx27 !== -1 &&
            updated[idx27] &&
            updated[idx27][`rps_${key}`] !== undefined &&
            updated[idx27][`rps_${key}`] !== ""
          ) {
            val27 = parseFloat(updated[idx27][`rps_${key}`]);
          }
          let ratio = "";
          if (val27 !== 0) {
            ratio = Math.round((val26 / val27) * 100000);
          }
          ratio26_27[key] = ratio;
        }
        const idx28 = EntryData.findIndex(item => Number(item.sector_id) === 28);
        if (idx28 !== -1) {
          for (let year = 2022; year <= 2047; year++) {
            const key = `${year}`.slice(-2);
            const newVal = ratio26_27[key];
            if (updated[idx28][`rps_${key}`] !== newVal) {
              updated[idx28][`rps_${key}`] = newVal;
              hasChanges = true;
            }
          }
        }
  
        return hasChanges ? { ...prevValues, Gsdp_estimates: updated } : prevValues;
      });
    }, 0);
  }, [formik.values.Gsdp_estimates, EntryData]);
  
  
  // const prepareSaveData = () => {
  //   let listOfIndicatorsEntry = [];

  //   if (!EntryData || EntryData.length === 0) {
  //     return { listOfIndicatorsEntry };
  //   }

  //   EntryData.forEach((detail, index) => {
  //     years.forEach((year) => {
  //       const gsdpPrice = parseFloat(formik.values.Gsdp_estimates[index]?.[`rps_${year}`]) || 0;
  //       const percentageYear = parseFloat( formik.values.Gsdp_estimates[index]?.[`percent_${year}`] ) || 0;

  //       if (gsdpPrice || percentageYear) {
  //         const startYear = `20${year}`; // Convert '23' -> '2023'
  //         // const endYear = parseInt(year) + 1; // Convert '23' -> '2024'

  //         listOfIndicatorsEntry.push({
  //           finYear: startYear, // Format: "2023"
  //           sectorId: detail.sector_id,
  //           broadSectorId: detail.broad_sector_id===null?0:detail.broad_sector_id,
  //           gsdpPrice: parseFloat(gsdpPrice.toFixed(2)),
  //           percentageYear: parseFloat(percentageYear.toFixed(2)),
  //         });
  //       }
  //     });
  //   });

  //   console.log("Processed Save Data:", listOfIndicatorsEntry);
  //   return { listOfIndicatorsEntry };
  // };


  const prepareSaveData = () => {
    let listOfIndicatorsEntry = [];
  
    if (!EntryData || EntryData.length === 0) {
      return { listOfIndicatorsEntry };
    }
  
    EntryData.forEach((detail, index) => {
      years.forEach((year) => {
        const nextYear = year + 1;
        const formKey = `20${year}_${nextYear}`;
        const formikGsdpPrice = formik.values.Gsdp_estimates[index]?.[`rps_${year}`];
        const formikPercentageYear = formik.values.Gsdp_estimates[index]?.[`percent_${year}`];
  
        const prevGsdpPrice = EntryData[index]?.[`gsdp_price_${formKey}`] || 0;
        const prevPercentageYear = EntryData[index]?.[`percentage_year_${formKey}`] || 0;
  
        
        let gsdpPriceNum = formikGsdpPrice !== "" ? parseFloat(formikGsdpPrice) || 0 : 0;
        let percentageYearNum = formikPercentageYear !== "" ? parseFloat(formikPercentageYear) || 0 : 0;
  
     
        if (prevGsdpPrice !== 0 && gsdpPriceNum == "") {
          gsdpPriceNum = 0;
        }
        if (prevPercentageYear !== 0 && percentageYearNum == "") {
          percentageYearNum = 0;
        }
  
     
        const shouldIncludeGsdp = gsdpPriceNum !== 0 || prevGsdpPrice !== 0;
        const shouldIncludePercentage = percentageYearNum !== 0 || prevPercentageYear !== 0;
  
        if (shouldIncludeGsdp || shouldIncludePercentage) {
          listOfIndicatorsEntry.push({
            finYear: `20${year}`,
            sectorId: detail.sector_id,
            broadSectorId: detail.broad_sector_id === null ? 0 : detail.broad_sector_id,
            gsdpPrice: gsdpPriceNum,
            percentageYear: percentageYearNum,
          });
        }
      });
    });
  
    console.log("Processed Save Data:", listOfIndicatorsEntry);
    return { listOfIndicatorsEntry };
  };
  

  const SaveData = () => {
    const requestData = prepareSaveData(); 
    console.log("Final Save Data:", requestData);

    let params = {
      type: "save",
      userId: username,
      districtId: roleid === "2" ? district : formik.values.district_id,
      mandalId: formik.values.mandal_id,
      sequanceId: sequenceId||"",
      ...requestData,
    };

    console.log("Final Params:", params);
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.gsdpestimatesSave(params).then((res) => {
      if (res.data.SCODE === "01") {
        showAlertMessage(res.data.SDESC, "success", () => {
          let paramss = {
            userId: username,
            districtId: roleid==="2"?district:formik.values.district_id,
            mandalId:roleid==="2"?formik.values.mandal_id:"",
          };
      
          KpiService.gsdpestimatesSector(paramss) .then((res) => { if (res.data.SCODE === "01") {
                setEntrydataEnb(true); setEntrydata(res.data.SDESC);
                // Log the backend data array to see its structure

                // let button=false
                res.data.SDESC.forEach((item, i) => {
      // console.log("dsec",res.data.SDESC)
      
                  for (let year = 2022; year <= 2047; year++) {
                    const nextYear = year + 1; const formKey = `${year}_${String(nextYear).slice(2)}`;  const frontend = `${year}`.slice(-2);
                    const gsdpValue = item[`gsdp_price_${formKey}`]; const percentageValue = item[`percentage_year_${formKey}`]; const finalGsdpValue = gsdpValue === 0 || gsdpValue === "0" ? "" : gsdpValue;
                    const finalPercentageValue = percentageValue === 0 || percentageValue === "0" ? "" : percentageValue;
                    store.dispatch({ type: "SHOW_SPINNER" });
                    formik.setFieldValue( `Gsdp_estimates[${i}].rps_${frontend}`, finalGsdpValue ); formik.setFieldValue( `Gsdp_estimates[${i}].percent_${frontend}`, finalPercentageValue );
                  }
                  if (item.sequance_id !== null) { setSequenceid(item.sequance_id); }

                  if (res.data.SDESC.some((item) => item.status_id === "2")) { setButtonenb(false); } 
                  else { setButtonenb(true); }

                });
            
              }

            })
            .catch((err) => { showAlertMessage("Failed to save data. Please try again.", "warning"); })
            .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
        })
      } 
      else { showAlertMessage(res.data.SDESC, "warning"); }
    }) .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  
  
  };


  // const SubmitData = () => {
  //   const requestData = prepareSaveData(); // Define first
  //   console.log("Final Save Data:", requestData);

  //   let params = {
  //     type: "submit",
  //     userId: username,
  //     districtId: roleid==="2"?district:formik.values.district_id,
  //     mandalId:roleid==="2"?formik.values.mandal_id:"",
  //     sequanceId: sequenceId||"",
  //     ...requestData,
  //   };

  //   console.log("Final Params:", params);
  //   store.dispatch({ type: "SHOW_SPINNER" });

  //   KpiService.gsdpestimatesSave(params).then((res) => {
  //     if (res.data.SCODE === "01") {
  //       showAlertMessage(res.data.SDESC, "success", () => {
  //         let paramss = {
  //           userId: username,
  //           districtId: roleid==="2"?district:formik.values.district_id,
  //           mandalId:roleid==="2"?formik.values.mandal_id:"",
  //         };
      
  //         KpiService.gsdpestimatesSector(paramss) .then((res) => { if (res.data.SCODE === "01") { setEntrydataEnb(true); setEntrydata(res.data.SDESC);
  //               // Log the backend data array to see its structure
  //               let button=false
  //               res.data.SDESC.forEach((item, i) => {
  //     console.log("dsec",res.data.SDESC)
      
  //                 for (let year = 2022; year <= 2047; year++) {
  //                   const nextYear = year + 1; const formKey = `${year}_${String(nextYear).slice(2)}`; console.log("formKey",formKey); const frontend = `${year}`.slice(-2); const gsdpValue = item[`gsdp_price_${formKey}`]; const percentageValue = item[`percentage_year_${formKey}`]; const finalGsdpValue = gsdpValue === 0 || gsdpValue === "0" ? "" : gsdpValue;
  //                   const finalPercentageValue = percentageValue === 0 || percentageValue === "0" ? "" : percentageValue;
  //                   store.dispatch({ type: "SHOW_SPINNER" });
  //                   formik.setFieldValue( `Gsdp_estimates[${i}].rps_${frontend}`, finalGsdpValue ); formik.setFieldValue( `Gsdp_estimates[${i}].percent_${frontend}`, finalPercentageValue );
  //                 }
  //                 if (item.sequance_id !== null) {setSequenceid(item.sequance_id);
  //                 }
  //                 if (res.data.SDESC.some((item) => item.status_id === "2")) {setButtonenb(false);
  //                 } else {setButtonenb(true);
  //                 }
  //               });
              
  //             }
  //           })
  //           .catch((err) => {showAlertMessage("Failed to save data. Please try again.", "warning");
  //           })
  //           .finally(() => {store.dispatch({ type: "HIDE_SPINNER" });
  //           });
  //       })
  //     } else {showAlertMessage(res.data.SDESC, "warning");
  //     }
  //   })  .catch((err) => {showAlertMessage("Failed to save data. Please try again.", "warning");
  //   })
  //   .finally(() => {store.dispatch({ type: "HIDE_SPINNER" });
  //   });
  // };

  return (
    <>
      <Menubar />
      <Container fluid className="map-header1">
        <div className="sa-title">
          <h2>
            GSDP <span> ESTIMATES</span>
          </h2>
        </div>
      </Container>

      <Container
        fluid
        style={{ width: "87%" }}
        className="outer-page-content-container"
      >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4 mt-2">
              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label className="mb-1 fw-bold"> DISTRICT </label>{" "}
                  <span style={{ color: "red" }}> *</span>
                  <Field
                    component="select"
                    name="district_id"
                    disabled={roleid === "2" ? true : false}
                    value={roleid === "2" ? district : formik.values.district_id}
                    className="form-control"
                    onChange={(e) => {
                      gethodData(e);
                      formik.handleChange(e);
                    }}
                  >
                    {" "}
                    <option value="0">--Select--</option> {distlist}{" "}
                  </Field>
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {" "}
                    <ErrorMessage name="district_id" />{" "}
                  </span>
                </Col>

                {/* <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mandal-col" >
                  <label className="mb-1 fw-bold"> CONSTITUENCY  </label> <span style={{ color: "red" }}> *</span>
                  <Field component="select" name="ddo_code" className="form-control" onChange={(e) => { MandalOrgData(e); formik.handleChange(e) }} > <option value="">--Select--</option> {ddolist} </Field>
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="ddo_code" /> </span>
                </Col> */}
                {roleid === "2" ? (
                  <Col
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    xxl={3}
                    className="mandal-col"
                  >
                    <label className="mb-1 fw-bold">MANDAL</label>{" "}
                    <span style={{ color: "red" }}> *</span>
                    <Field
                      component="select"
                      name="mandal_id"
                      className="form-control"
                      onChange={(e) => {
                        getGsdpEstimates(e.target.value);
                        formik.handleChange(e);
                      }}
                    >
                      <option value="">--Select--</option> {mandallist}{" "}
                    </Field>
                    <span style={{ color: "red", fontSize: "13px" }}>
                      {" "}
                      <ErrorMessage name="mandal_id" />{" "}
                    </span>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            </div>

            <br />

            {entrydataEnb && (
              <>
                <br />
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: "#603913",
                    color: "white",
                  }}
                  className="rounded-1 border py-1"
                >
                  <span>
                    <h6>
                      {" "}
                      GSDP at currrent Prices &nbsp;
                      <br />
                      <br />{" "}
                      {roleid === "2"
                        ? `Mandal - ${mandalName}`
                        : `District - ${districtName}`}
                    </h6>
                  </span>
                </div>

                {/* <div
                  style={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    overflowY: "hidden",
                  }}
                > */}

<div id="table-scroll"className="table-scroll">
<div className="table-wrap">
                  <table
                    bordered
                    hover
                    id="my-table"
                    className="table table-bordered custom-table table-responsive sticky-table"
                  >
                    <thead>
                      <tr className="text-center">
                        <th style={{ backgroundColor: "#603913" }} className="sticky-col sticky-sno" rowSpan={4} > {" "} Sector name{" "} </th>
                        <th style={{ backgroundColor: "#603913" }} className="sticky-col sticky-sector" rowSpan={4} > Industry </th>
                      </tr>

                      <tr>
                        {generateYears().map((year) => (
                          <th key={year} style={{ backgroundColor: "#603913", color: "#fff", }} className={ year === "2022-23" ? "sticky-col sticky-year" : "" } colSpan={year.startsWith("2022") ? 1 : 2} > {year} </th>
                        ))}
                      </tr>

                      <tr>
                        {Array.from({ length: 26 }).map((_, index) => (
                          <React.Fragment key={index}>
                            {index > 0 && (
                              // <th className={`percent-column ${index === 1 ? "sticky-col sticky-percent" : ""}`} style={{ backgroundColor: "#603913", color: "white" }} > % </th> )}
                              <th className="percent-column" style={{ backgroundColor: "#603913", color: "white", }} > {" "} %{" "} </th>
                            )}
                            <th style={{ backgroundColor: "#603913", color: "white", minWidth: "140px", }} className={ index < 1 ? "sticky-col sticky-year" : "" } > {" "} Rs.in Lakhs{" "} </th>

                          </React.Fragment>
                        ))}
                      </tr>

                      <tr>
                        {Array.from({ length: 51 }).map((_, index) => (
                          <React.Fragment key={index}>
                           <th className={ index < 1 ? "sticky-col sticky-year" : "" } style={{ backgroundColor: "#603913", color: "white", }} > {index + 1} </th>

                          </React.Fragment>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
  {EntryData?.length === 0 || EntryData?.length === undefined ? (
    <tr>
      <td className="text-center" colSpan="6">
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    (() => {
      const displayedKeys = new Set();
      return EntryData?.map((detail, i) => {
        const uniqueKey = `${detail.bs_name}`;
        const showValues = !displayedKeys.has(uniqueKey);
        if (showValues) displayedKeys.add(uniqueKey);

        return (
          <tr key={i}>
             <td style={{ textAlign: "left" }} className="sticky-col sticky-sno"> {showValues ? detail.bs_name : ""} </td> 
            {/* <td className="sticky-col sticky-sno">{detail.bs_name}</td> */}
            <td className="sticky-col sticky-sector" style={{
  backgroundColor: detail.sector_id === 6 || detail.sector_id === 11 || detail.sector_id === 21 
    ? "rgb(255 219 154)"
    : "white"
}}
>{detail.sector_name}</td>
            {years.map((year) => (
              <React.Fragment key={`year_${year}`}>
                    {(year !== 48 && year !== 22 )&& (
                  <td>
                    {![6, 11, 21, 22, 25,28].includes(detail.sector_id) && (
                      <Field
                        autoComplete="off"
                        className="form-control"
                        name={`Gsdp_estimates[${i}].percent_${year}`}
                        onChange={(e) => {
                          // Update the field value and set manualOverride flag for this row
                          const newValue = e.target.value;
                          formik.setFieldValue(`Gsdp_estimates[${i}].percent_${year}`, newValue);
                          formik.setFieldValue(`Gsdp_estimates[${i}].percent_`, true);
                        }}
                        onKeyPress={(e) => percentcal(e)}
                        disabled={ detail.sector_id === 27 ?true:false}
                        type="text"
                        style={{ textAlign: "right" }}
                      />
                    )}
                  </td>
                )}
                  {(year !== 48  )&& (
                <td className={`sticky-col ${year === 22 ? "sticky-year" : ""}`}>
                  <Field
                    autoComplete="off"
                    className={`form-control ${
                      year === 22 ? "sticky-col sticky-year" : ""
                    }`}
                    onChange={(e) => {
                      // Update the field value and set manualOverride flag for this row
                      const newValue = e.target.value;
                      formik.setFieldValue(`Gsdp_estimates[${i}].rps_${year}`, newValue);
                      formik.setFieldValue(`Gsdp_estimates[${i}].manualOverride`, true);
                    }}
                    name={`Gsdp_estimates[${i}].rps_${year}`}
                    onKeyPress={(e) => isValidtwo(e)}
                    disabled={
                      detail.sector_id === 27 
                        ? false 
                        : ([6, 11, 21, 22, 25, 28].includes(detail.sector_id) || year > 22)
                    }
                    
                    type="text"
                    style={{ textAlign: "right" }}
                  />
                </td>
                  )}
                {/* {year !== 47 && (
                  <td>
                    {![6, 11, 21, 22, 25,28].includes(detail.sector_id) && (
                      <Field
                        autoComplete="off"
                        className="form-control"
                        name={`Gsdp_estimates[${i}].percent_${year}`}
                        onKeyPress={(e) => percentcal(e)}
                        disabled={detail.sector_id===27?true:false}
                        type="text"
                        style={{ textAlign: "right" }}
                      />
                    )}
                  </td>
                )} */}
              </React.Fragment>
            ))}
          </tr>
        );
      });
    })()
  )}
</tbody>


                  </table>
                </div>
                </div>
                {buttonenb &&
                <div className="bottom-buttons d-flex justify-content-center  mt-4 mb-5">
                  <Button
                    variant=""
                    size="sm"
                    className="save-btn me-4"
                    onClick={() => SaveData()}
                  >
                    {" "}
                    Save <FaRegSave className="ms-1 s-icon" />{" "}
                  </Button>
                  {/* <Button variant="" size="sm" className="next-btn me-4" onClick={() => SubmitData()} > {" "} Submit{" "} <IoReturnDownForward style={{ fontSize: "18px", marginLeft: "5px" }} />{" "} </Button> */}
                </div>}
              </>
            )}
            <AlertModal
              show={showAlert}
              titleText={alertData.titleText}
              alertText={alertData.alertText}
              onClose={closeAlert}
            />
          </Form>
        </FormikProvider>
      </Container>
    </>
  );
}
